module.exports = __webpack_public_path__ + "img/layout_horizontal_right.59bae3f3.svg";